import script from "./dashbExprBilan.vue?vue&type=script&setup=true&lang=ts"
export * from "./dashbExprBilan.vue?vue&type=script&setup=true&lang=ts"

import "./dashbExprBilan.vue?vue&type=style&index=0&id=72f9f0fc&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72f9f0fc"]])

export default __exports__